import type { StatsListQuery } from '../../../../services/competition/getStatsPage'

interface StatTypeRef {
  id: string | number
  abbr?: string
}

interface BuildTeamStatsQueryArgs {
  /** The stats path the Team Statistics filters picked. */
  path: string
  /** The team-wide path (`/teams/:id/stats/players`), sorted by abbreviation. */
  basePath: string
  sortBy: string | number | null
  direction: 'asc' | 'desc'
  isGoalieStats: boolean
  /** The division/schedule picked in the filters, if any. */
  scheduleForSearch: string | null
  statTypes: StatTypeRef[]
}

/**
 * The query for one Team Statistics request.
 *
 * - The team-wide path sorts by stat abbreviation; the schedule paths by id.
 * - `division_id` is sent only when the path is not already scoped to that
 *   schedule — matched as a whole `/schedules/:id` segment, so `div9` does not
 *   match inside `div99`.
 */
export const buildTeamStatsQuery = ({
  path,
  basePath,
  sortBy,
  direction,
  isGoalieStats,
  scheduleForSearch,
  statTypes,
}: BuildTeamStatsQueryArgs): StatsListQuery => {
  const resolvedSortBy =
    path === basePath
      ? statTypes.find((stat) => stat.id === sortBy)?.abbr
      : sortBy

  const isScheduleInPath = scheduleForSearch
    ? new RegExp(`/schedules/${scheduleForSearch}(?:/|$)`).test(path)
    : false

  return {
    sortBy: resolvedSortBy,
    sort: direction,
    goalie: isGoalieStats ? 1 : 0,
    division_id:
      scheduleForSearch && !isScheduleInPath ? scheduleForSearch : undefined,
  }
}
